<script>

  import {formatSecondsTimeStamp
  } from "../static";
  import {External, M} from "../../external";
  import ContentOverlayProperties from "./ContentOverlayProperties.svelte";
  import Loader from "../../Common/Loader.svelte";

  export let video;

  let videoContents = video.contentOverlay ? JSON.parse(video.contentOverlay) : [];
  let loading = false;

  let showContentOverlay = (contentOverlay) => {
    let isNew = !contentOverlay;
    if (!contentOverlay) {
      contentOverlay = {
        name: 'Content overlay ' + (videoContents.length + 1),
        content: '',
        elementId: video.elementId + '_' + Date.now(),
        showAt: 0,
        hideAt: 5,
        layoutClass: 'center',
        backgroundColor: '#fff',
        fullHeight: false
      }
    }
    External.Tools.showWindow({
      isModal: true,
      width: 1400,
      noTitle: true,
      withDarkBackground: false,
      customClass: 'working-area-wrapper',
      action: {
        onShow: (popup, context) => {
          popup.bindComponent(
              new ContentOverlayProperties({
                target: popup.getContentArea(),
                props: {
                  video: video,
                  contentOverlay: contentOverlay,
                  popup: popup,
                }
              })
          );
        },
        onHide: () => {
          External.Tools.makeWebsiteRequest({
            action: 'renderWidgets',
            method: 'post',
            data: {
              widgets: contentOverlay.content
            },
            onOk: function (result) {
              contentOverlay.renderedContent = result.data;
              if (isNew) {
                addNewContentOverlay(contentOverlay);
              } else {
                updateContentOverlay(contentOverlay);
              }
            }
          });
        }
      }
    });
  }

  let addNewContentOverlay = (contentOverlay) => {
    videoContents.unshift(contentOverlay);
    reorderContentOverlay();
    videoContents = videoContents;
  }

  let updateContentOverlay = (contentOverlay) => {
    videoContents = videoContents.map((item) => {
      if (item.elementId === contentOverlay.elementId) {
        return contentOverlay;
      }
      return item;
    });
    reorderContentOverlay();
  }

  let reorderContentOverlay = () => {
    videoContents = videoContents.sort((a, b) => a.showAt - b.showAt);
    video.contentOverlay = JSON.stringify(videoContents);
  }

  let removeContentOverlay = (elementId) => {
    videoContents = videoContents.filter((item) => item.elementId !== elementId);
    video.contentOverlay = JSON.stringify(videoContents);
  }

</script>

<div>
  <div class="popup-widget-wrapper">
    <div class="col20 f-left t-center mt-5">
      <span class="material-icons-outlined fingerprint-icon"> touch_app </span>
    </div>
    <h4 class="col20 f-left mt-15 mb-5 t-center h4-bigger">{M.VIDEO_CONTENT_OVERLAY}</h4>
    <span class="light-gray-text t-center col20 f-left mb-15">{M.VIDEO_CONTENT_OVERLAY_DESC}</span>
    <div class="col20 f-left t-center">
      <a class="middle-button blue with-icon inline-block f-none" on:click={() => showContentOverlay(null)}>Add Content</a>
    </div>

    <ul class="col20 f-left small-rules mt-10">
      {#if loading}
        <Loader/>
      {:else}
        {#each videoContents as overlayContent}
          <li class="col20 f-left" on:click={() => showContentOverlay(overlayContent)}>
            <div class="add-automation-rule flex align-center col20">
              <span class="material-icons-outlined circle-automation-icon blue-border">add_box</span>
              <div class="flex-1">
                <span class="col20 f-left light-gray-text t-left mb-5">{formatSecondsTimeStamp(overlayContent.showAt)} - {formatSecondsTimeStamp(overlayContent.hideAt)}</span>
                <h5>{overlayContent.name}</h5>
              </div>
              <a class="mr-5"><span class="material-icons-outlined">settings</span></a>
              <a class="mr-5" on:click|stopPropagation={() => removeContentOverlay(overlayContent.elementId)}><span class="material-icons-outlined">delete</span></a>
            </div>
          </li>
        {/each}
      {/if}
    </ul>

  </div>
</div>

<style>
    .filter-nav .container-type li {
        width: auto;
    }

    .filter-nav .container-type li.active a:before,
    .filter-nav .container-type li:hover a:before {
        display: none;
    }

    .video-content-wrapper {
        width: 100%;
        float: left;
        padding: 50px;
        box-sizing: border-box;
    }

    .popup-widget-wrapper.smaller {
        padding: 0 30px 30px;
    }

    .add-widget-video-content {
        top: -15px;
    }
</style>
